module.exports = {"Last performance":"הסביבה היסטור "}


//////////////////
// WEBPACK FOOTER
// ./src/assets/translations/iw-iw.json
// module id = N7SD
// module chunks = 1